import _ from 'lodash'
import axios from 'axios'
import Qs from 'qs'

import config from '../../config'
import getCommerceChannel from '../../helpers/get-commerce-channel'
import applyCaseConvert from './apply-case-convert'
import getLocaleParam from './get-locale-param'

// creating the axios api instance for omnitech api
const client = applyCaseConvert(axios.create())

// construct api call url
function getUrl(endpoint, options) {
  const apiHost = config.get("api.host");
  const locale = getLocaleParam();
  const commerceChannel = getCommerceChannel(options);
  const apiChannel = config.get("api.apiChannel");
  return `${apiHost}/api/v2/${locale}/${apiChannel}_${commerceChannel}/${endpoint}`;
}

function setAuthorizationHeader({ authToken, deviceUdid }) {
  client.defaults.headers.common['X-AUTH-TOKEN'] = authToken
  client.defaults.headers.common['X-DEVICE-UDID'] = deviceUdid
  client.defaults.headers.common['web-app-version'] = config.get('appVersion')
}

// send request to api endpoint
function request(options) {
  const {
    arrayFormat = 'comma',
    data = {},
    endpoint,
    ...others
  } = options
  const keysToGetCommerceChannel = ['type', 'commerceChannel', 'orderMethodMandatory']
  let params = _.get(options, 'params', {})
  const getCommerceChannelOptions = {
    ..._.pick(others, keysToGetCommerceChannel),
    ..._.pick(params, keysToGetCommerceChannel),
  }
  const url = getUrl(endpoint, getCommerceChannelOptions);
  const commerceChannel = getCommerceChannel(getCommerceChannelOptions);
  params = _.omit(params, keysToGetCommerceChannel)

  // default schemaVersion
  const schemaVersion = '2024-04-11'

  let body = {}
  // handle schemaVersion placement
  // method is `get` then put schemaVersion in `params` else put in `body`
  if (options.method === 'get') {
    params = {
      schemaVersion,
      // if `params` has schemaVersion then it will override the default
      ...params,
    }
  } else {
    body = {
      // if params has schemaVersion then use that instead of the default schemaVersion
      schemaVersion: _.get(params, 'schemaVersion') || schemaVersion,
      // if `body` has schemaVersion then it will override the default
      ...data,
    }
    // remove unused params if it was passed in originally
    params = _.omit(params, ['schemaVersion', 'commerceChannel'])
  }

  const paramsSerializer = (p) => {
    let paramsInCommaArrayFormat = ''
    let paramsInBracketsArrayFormat = ''
    const {
      includes = [],
      scopes = [],
      ...rest
    } = p

    // `includes` arrayFormat always in `comma` format
    if (
      !_.isEmpty(includes)
    ) {
      paramsInCommaArrayFormat = _.join(
        _.compact([
          paramsInCommaArrayFormat,
          Qs.stringify({ includes }, { arrayFormat: 'comma' }),
        ]),
        '&',
      )
    }

    // `scopes` arrayFormat always in `brackets` format
    if (
      !_.isEmpty(scopes)
    ) {
      paramsInBracketsArrayFormat = _.join(
        _.compact([
          paramsInBracketsArrayFormat,
          Qs.stringify({ scopes }, { arrayFormat: 'brackets' }),
        ]),
        '&',
      )
    }

    return _.join(
      _.compact([
        paramsInCommaArrayFormat,
        paramsInBracketsArrayFormat,
        Qs.stringify(rest, { arrayFormat }),
      ]),
      '&',
    )
  }

  return client.request({
    url,
    // data is only applicable for request methods 'PUT', 'POST', 'DELETE , and 'PATCH'
    ...others,
    data: !_.isEmpty(body) ? body : undefined,
    params,
    paramsSerializer,
  }).then((data) => ({
    ...data,
    // add commerceChannel to the response
    commerceChannel,
  }))
}

export default {
  client,
  request,
  setAuthorizationHeader
}
